// @givmo/app-charity — `/donations`: the module's landing (CPA-WEB40 · §9-A A1 · A7).
//
// The class default's landing page is the certified statement (`GrantsScreen` — V2 or the legacy
// page, by its own knob), with the getting-started strip above it for as long as any of Terms ·
// Payments · Profile remains. Every charity admin lands here from the root, so this is where the
// strip earns its place; it never renders on any other page.

import { GettingStartedStrip } from './getting-started-strip';
import { GrantsScreen } from '../grants/grants-screen';
import { useActiveOrg } from '../../org/active-org-context';

export function DonationsLanding() {
  const { activeCharityId } = useActiveOrg();
  return (
    <>
      {activeCharityId !== null && (
        <GettingStartedStrip charityId={activeCharityId} className="mx-16 mt-16 lg:mx-24" />
      )}
      <GrantsScreen />
    </>
  );
}
